import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import figureFormatter from '@/services/utils/figureFormatter'
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import { formatToDdMmYy, formatDate } from '@/services/utils/global.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const paymentVoucherPdfPrinter = () => {
    const {currencyToDigitWord} = handlePurchase();
    const {commaFormat} = figureFormatter();
    const store = useStore();
    const userName = store.state.user.user.name;
    const exportToPDF = (company, data, barcode, qrcode, incentivePayment, totalValue) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 80 ],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(data, incentivePayment, barcode),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: data.voucher_no
            }
        }

        pushIntoTable(doc, data, incentivePayment, totalValue)
        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getHeader = (company) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        (company.name) ? company.name : '',
                        (company.address) ? 'Address: ' + company.address : '',
                        (company.phone) ? 'Phone: ' + company.phone : '',
                        (company.email) ? 'E-mail: ' + company.email : '',
                        (company.vat_no) ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }

    const getContent = (data, tableItems, barcode) => {
        return  [
            {
                text: "INCENTIVE PAYMENT VOUCHER",
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '40%',
                        stack: [
                            {
                                text: [
                                    { text: 'Staff ID: ', bold: true },
                                    { text: data.serial_no }
                                ]
                            },
                            {
                                text: [
                                    { text: 'Name: ', bold: true },
                                    { text: data.full_name }
                                ]
                            },
                            {
                                text: [
                                    { text: 'Total Amount: ', bold: true },
                                    { text: data.total_amount }
                                ]
                            },
                        ]
                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: [
                                    { text: 'VOUCHER DATE: ', bold: true },
                                    { text: formatToDdMmYy(data.date) }
                                ]
                            },

                            {
                                text: [
                                    { text: 'VOUCHER NO: ', bold: true },
                                    { text: data.voucher_no }
                                ]
                            },

                            {
                                svg: barcode
                            },
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['auto', 'auto', 'auto', 'auto', "auto", "auto", "auto", "auto", "auto"],
                    body: []
                },
                layout: {
			          fillColor: function (rowIndex) {
                            return (rowIndex === 0 || rowIndex === tableItems.length + 1) ? '#f3f2f7' : null;
                        },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
		        }
		    },

            {
                columns: [
                    {
                        width: '65%',
                        text: [
                            {
                                text: 'Amount in word: ',
                                bold: true
                            },

                            {
                                text: data.total_amount ? currencyToDigitWord((data.total_amount.toFixed(2)), false, true) : ''
                            }
                        ]
                    }
                ],
                margin: [0, 10]
            },

            {
                alignment: 'justify',
                text: [{ text: data.note ? 'Voucher Memo \n' : '', bold: true}, {text: data.note} ]
            },
        ]
    }

    const getFooter = (userName, qrcode) =>{
        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        {
                            svg: qrcode
                        },

                        {
                            width: '90%',
                            alignment: 'left',
                            text: '',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    const pushIntoTable = (doc, data, tableItems, totalValue) => {
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);
        tableItems.forEach(item => {
            const rowData = getRowData(item);
            doc.content[2].table.body.push(rowData);
        });

        doc.content[2].table.body.push(
            [
                { text: 'Total', alignment: 'right', colSpan: 4 }, '', '','',
                { text: commaFormat(totalValue.total_personal_sales_commission), alignment: 'right' },
                { text: commaFormat(totalValue.total_group_commission_amount), alignment: 'right' },
                { text: commaFormat(totalValue.total_company_sale_share), alignment: 'right' },
                { text: commaFormat(totalValue.total_group_bp_commission_amount), alignment: 'right' },
                { text: commaFormat(totalValue.total_commission), alignment: 'right' }
            ]
        );
    }

    const getTableHeader = () => {
        return [
            { text: 'Staff ID' },
            { text: 'Staff Name' },
            { text: 'Designation' },
            { text: 'Ref ID' },
            { text: 'Personal Sales Commission', alignment: 'right' },
            { text: 'Group Sales Commission', alignment: 'right' },
            { text: 'Company Sales Share', alignment: 'right' },
            { text: 'BP Commission', alignment: 'right' },
            { text: 'Total Commission', alignment: 'right' },
        ]
    }

    const getRowData = (item) => {
        return [
            { text: item.serial_no },
            { text: item.name },
            { text: item.level_name + '(' + item.equivalent_designation + ')' },
            { text: item.parent_serial_no },
            { text: commaFormat(item.personal_sales_commission), alignment: 'right' },
            { text: commaFormat(item.total_group_commission_amount), alignment: 'right' },
            { text: commaFormat(item.total_company_sale_share), alignment: 'right' },
            { text: commaFormat(item.total_group_bp_commission_amount), alignment: 'right' },
            { text: commaFormat(item.total_commission), alignment: 'right' },
        ]
    }

    return {
        exportToPDF
    }
}

export default paymentVoucherPdfPrinter;
